export default __webpack_public_path__ + "static/media/training-closer-image.028176e4.svg";